import { render, staticRenderFns } from "./jackpot-popups.vue?vue&type=template&id=19b3b0c1&scoped=true"
import script from "./jackpot-popups.vue?vue&type=script&lang=js"
export * from "./jackpot-popups.vue?vue&type=script&lang=js"
import style0 from "./jackpot-popups.vue?vue&type=style&index=0&id=19b3b0c1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b3b0c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19b3b0c1')) {
      api.createRecord('19b3b0c1', component.options)
    } else {
      api.reload('19b3b0c1', component.options)
    }
    module.hot.accept("./jackpot-popups.vue?vue&type=template&id=19b3b0c1&scoped=true", function () {
      api.rerender('19b3b0c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/desktop/jackpot-popups.vue"
export default component.exports